export async function apiFetch(url, options = {}) {
  const auth = JSON.parse(localStorage.getItem("auth") || "{}");
  const token = auth?.token;

  const isFormData = options.body instanceof FormData;

  const headers = {
    ...(options.headers || {}),   // keep existing headers
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...(isFormData ? {} : { "Content-Type": "application/json" })
  };

  try {
    return await fetch(url, {
      ...options,
      headers
    });
  } catch (err) {
    return {
      ok: false,
      status: 0,
      statusText: err?.message || "Failed to fetch",
      json: async () => ({}),
      text: async () => "",
    };
  }
}
